import objectFitImages from 'object-fit-images';
// import ImageBuddy from 'imagebuddy';
import Cookies from 'js-cookie';

import SiteHeader from './components/site-header';
import MobileMenu from './components/mobile-menu';
import ConnectedRecruitingMenu from './components/connected-recruiting-menu';
import Modal from './components/modal';
import Banner from './components/banner';
import PartnerOffers from './components/partner-offers';
import GatedResource from './components/gated-resource';
import GridQuickNav from './components/grid-quick-nav';

import PostsListCaseStudy from './components/posts-list/posts-list-case-study';
import PostsListCustomerBlog from './components/posts-list/posts-list-customer-blog';
import PostsListResource from './components/posts-list/posts-list-resource';
import PostsListAutomation from './components/posts-list/posts-list-automation';
import PostsListAiContentLibrary from './components/posts-list/posts-list-ai-content-library';
import PostsListEvent from './components/posts-list/posts-list-event';
import PostsListPartner from './components/posts-list/posts-list-partner';
import PostsListBlog from './components/posts-list/posts-list-blog';
import PostsListMediaCoverage from './components/posts-list/posts-list-media-coverage';
import PostsListPressRelease from './components/posts-list/posts-list-press-release';

import ArchiveBlog from './templates/archive-blog';
import SearchResults from './templates/search-results';
import SinglePost from './templates/single-post';

import BlockTestimonials from './blocks/testimonials';
import BlockCTA from './blocks/cta';
import BlockColumns from './blocks/columns';
import BlockStats from './blocks/stats';
import BlockSidebarAnchor from './blocks/sidebar-anchor';
import AutomationSidebarAnchor from './util/automation-sidebar-anchor';
import AIContentLibrarySidebarAnchor from './util/ai-content-library-sidebar-anchor';
import BlockMedia from './blocks/media';
import BlockRelatedResources from './blocks/related-resources';
import BlockContentMedia from './blocks/content-media';

import { processExternalLinks, scrollTo } from './util/general-util';
import ScrollWatcher from './util/scroll-watcher';
import SiteEvents, { SiteEventNames } from './util/site-events';
import BlockAnimationWatcher from './util/block-animation-watcher';
import ParallaxFxWatcher from './util/parallax-fx-watcher';
import HelloBar from './util/hello-bar';
import setupEventDelegators from './util/setup-event-delegators';
import {
	showVideoModal,
	showTeamModal,
	showDemoModal,
	getDemoModalParams,
	showFormModal,
	showContentModal,
	showGridModal,
	getGridModalParams
} from './util/modal-helpers';

import Marketo from './integrations/marketo';

import InternalQueryParams from './util/internal-query-params';

import ChartBlock from './util/chart-blocks';

class App {
	constructor() {
		this.instances = {
			components: {
				siteHeader: null,
				mobileMenu: null,
				connectedRecruitingMenu: null,
				banner: null,
				partnerOffers: [],
				gatedResource: [],
				quickNav: [],
				postsListCaseStudy: [],
				postsListCustomerBlog: [],
				postsListResource: [],
				postsListAutomation: [],
				postsListAiContentLibrary: [],
				postsListEvent: [],
				postsListPartner: [],
				postsListBlog: [],
				postsListMediaCoverage: [],
				postsListPressRelease: []
			},
			templates: {
				archiveBlog: null,
				searchResults: null,
				singlePost: null
			},
			blocks: {
				testimonials: [],
				cta: [],
				columns: [],
				stats: [],
				sidebarAnchor: [],
				media: [],
				relatedResources: [],
				contentMedia: []
			},
			scrollWatcher: null,
			// imageBuddy: null,
			blockAnimationWatcher: null,
			parallaxFxWatcher: null,
			helloBar: null
		};

		this.init();
		this.initComponents();
		this.initTemplates();
		this.initBlocks();
		this.initSocialShare();
		this.initFX();
	}

	init() {
		processExternalLinks({
			target: '_blank',
			rel: 'noopener'
		});

		Modal.setDefaults({
			closeDuration: 400,
			closeButtonContent: `
				<svg xmlns="http://www.w3.org/2000/svg" class="modal__close-icon" viewBox="0 0 14 14">
					<path d="M11.378 13.208l1.809-1.81a.802.802 0 000-1.136L9.924 7l3.263-3.262a.802.802 0 000-1.137L11.378.792a.802.802 0 00-1.136 0L6.979 4.055 3.717.792a.802.802 0 00-1.137 0L.771 2.602a.802.802 0 000 1.136L4.034 7 .771 10.262a.802.802 0 000 1.137l1.81 1.809a.802.802 0 001.136 0l3.262-3.263 3.263 3.263a.802.802 0 001.136 0z" fill="currentColor"/>
				</svg>
				<span class="modal__close-text">Close</span>
			`.trim()
		});

		/**
		 * GRID - Data Visualization
		 */
		if (document.getElementsByClassName('tmpl-grid-data').length) {
			const chart = new ChartBlock();
			chart.init();
		}

		/**
		 * Marketo init
		 */
		const marketoApiParams = window?.apiSettings?.marketo ?? null;

		if (marketoApiParams) {
			Marketo.init(
				marketoApiParams.munchkinId ?? '',
				marketoApiParams.scriptURL ?? '',
				marketoApiParams.baseURL ?? ''
			);
		}

		/**
		 * Setup event delegators
		 */
		setupEventDelegators('body', {
			'js--trigger-video-modal': (el) => {
				const videoUrl = el.href || '';

				showVideoModal(videoUrl);
			},
			'js--trigger-team-modal': (el) => {
				const imgEl = el.querySelector('.block-team__card-image');

				const params = {
					ibSources: imgEl ? imgEl.getAttribute('src') : '',
					name: el.querySelector('.block-team__card-name')?.textContent ?? '',
					role: el.querySelector('.block-team__card-role')?.textContent ?? '',
					bio: el.querySelector('.block-team__bio-container')?.innerHTML ?? ''
				};

				showTeamModal(params);
			},
			'js--trigger-demo-modal': () => {
				showDemoModal(getDemoModalParams());
			},
			'js--trigger-grid-modal': () => {
				showGridModal(getGridModalParams());
			},
			'js--trigger-form-modal': (el) => {
				const formId = el.getAttribute('data-form-id') || '';

				if (!formId) {
					return;
				}

				showFormModal(formId);
			},
			'js--trigger-content-modal': (el) => {
				const formId = el.getAttribute('data-form-id') || '';

				if (!formId) {
					return;
				}

				showContentModal(formId);
			}
		});

		// add Grid modal trigger for links with "#show-grid-modal" href values
		const gridModalTriggerEls = Array.from(
			document.querySelectorAll('a[href="#show-grid-modal"]')
		);

		gridModalTriggerEls.forEach((triggerEl) => {
			triggerEl.setAttribute('role', 'button');
			triggerEl.addEventListener('click', (e) => {
				e.preventDefault();

				showGridModal(getGridModalParams());
			});
		});

		// add form modal trigger for links with "#show-form-modal-*" href values
		const formModalTriggerEls = Array.from(
			document.querySelectorAll('a[href^="#show-form-modal-"]')
		);

		formModalTriggerEls.forEach((triggerEl) => {
			triggerEl.setAttribute('role', 'button');
			triggerEl.addEventListener('click', (e) => {
				e.preventDefault();

				const targetHref = e.currentTarget.getAttribute('href') || '';

				if (!targetHref) {
					return;
				}

				const formId = targetHref.replace('#show-form-modal-', '');

				showFormModal(formId);
			});
		});

		// add content modal trigger for links with "#show-content-modal-*" href values
		const contentModalTriggerEls = Array.from(
			document.querySelectorAll('a[href^="#show-content-modal-"]')
		);

		contentModalTriggerEls.forEach((triggerEl) => {
			triggerEl.setAttribute('role', 'button');
			triggerEl.addEventListener('click', (e) => {
				e.preventDefault();

				const targetHref = e.currentTarget.getAttribute('href') || '';

				if (!targetHref) {
					return;
				}

				const formId = targetHref.replace('#show-content-modal-', '');

				showContentModal(formId);
			});
		});

		// scroll watcher init
		this.scrollWatcher = new ScrollWatcher((params) => {
			ScrollWatcher.defaultCallback(params, 100);
		});

		// initialize ImageBuddy and setup events
		// this.instances.imageBuddy = new ImageBuddy({
		// 	lazyLoad: true
		// 	// debug: true
		// });

		// ImageBuddy.on('image-loaded', (imgEl) => {
		// 	objectFitImages(imgEl);
		// });

		// SiteEvents.subscribe(SiteEventNames.IMAGEBUDDY_TRIGGER_UPDATE, (opts) => {
		// 	this.instances.imageBuddy.update(opts || {});
		// });

		this.instances.helloBar = new HelloBar();
		this.instances.helloBar.init();

		this.InternalQueryParams = new InternalQueryParams();

		// ObjectFitImages: only act upon images that have a valid src attribute
		// Note: use the 'object-fit-polyfill' SCSS mixin to create the necessary 'font-family' attribute
		objectFitImages('img:not([src^="data:"])');

		// set the "preferred_site_id" cookie when the site switcher is used
		const siteSwitcherLinkEls = Array.from(document.querySelectorAll('a[data-site-id]'));

		siteSwitcherLinkEls.forEach((linkEl) => {
			linkEl.addEventListener('click', (e) => {
				e.preventDefault();

				Cookies.set(
					'preferred_site_id',
					e.currentTarget.getAttribute('data-site-id') || ''
				);

				window.location = e.currentTarget.getAttribute('href') || '#';
			});
		});

		// smooth scrolling for anchor links
		const anchorLinkEls = Array.from(document.querySelectorAll('a[href^="#"]'));

		anchorLinkEls.forEach((linkEl) => {
			if (linkEl.getAttribute('href') === '#') {
				linkEl.setAttribute('role', 'button');
				return;
			}

			linkEl.addEventListener('click', (e) => {
				e.preventDefault();

				const headerEl = document.querySelector('.site-header');

				scrollTo(
					e.currentTarget.getAttribute('href'),
					headerEl ? headerEl.getBoundingClientRect().height : 0
				);
			});
		});
	}

	async initComponents() {
		// site header
		const siteHeaderEl = document.querySelector('.site-header');

		if (siteHeaderEl) {
			this.instances.components.siteHeader = new SiteHeader(siteHeaderEl);
		}

		// mobile menu
		const mobileMenuEl = document.querySelector('.site-header__mobile-container');

		if (mobileMenuEl) {
			this.instances.components.mobileMenu = new MobileMenu(mobileMenuEl);
		}

		// connected recruiting menu
		const connectedRecruitingMenuEl = document.querySelector('.recruiting-container');

		if (connectedRecruitingMenuEl) {
			this.instances.components.connectedRecruitingMenu = new ConnectedRecruitingMenu(
				connectedRecruitingMenuEl
			);
		}

		// banner
		const bannerEl = document.querySelector('.banner-default');

		if (bannerEl) {
			this.instances.components.banner = new Banner(bannerEl);
		}

		// partner offers
		Array.from(document.querySelectorAll('.partner-offers')).forEach((partnerOffersEl) => {
			this.instances.components.partnerOffers.push(new PartnerOffers(partnerOffersEl));
		});

		// gated resource
		Array.from(document.querySelectorAll('[data-gated-form-id]')).forEach((gatedResourceEl) => {
			this.instances.components.gatedResource.push(new GatedResource(gatedResourceEl));
		});

		// posts list - case study
		Array.from(document.querySelectorAll('.posts-list--case-study')).forEach(
			(postsListCaseStudyEl) => {
				this.instances.components.postsListCaseStudy.push(
					new PostsListCaseStudy(postsListCaseStudyEl)
				);
			}
		);

		// posts list - customer blog
		Array.from(document.querySelectorAll('.posts-list--customer-blog')).forEach(
			(postsListCustomerBlogEl) => {
				this.instances.components.postsListCustomerBlog.push(
					new PostsListCustomerBlog(postsListCustomerBlogEl)
				);
			}
		);

		// posts list - resource
		Array.from(document.querySelectorAll('.posts-list--resource')).forEach(
			(postsListResourceEl) => {
				this.instances.components.postsListResource.push(
					new PostsListResource(postsListResourceEl)
				);
			}
		);

		// posts list - automation
		Array.from(document.querySelectorAll('.posts-list--automation')).forEach(
			(postsListAutomationEl) => {
				this.instances.components.postsListAutomation.push(
					new PostsListAutomation(postsListAutomationEl)
				);
			}
		);

		// posts list - ai content library
		Array.from(document.querySelectorAll('.posts-list--ai-content-library')).forEach(
			(postsListAiContentLibraryEl) => {
				this.instances.components.postsListAiContentLibrary.push(
					new PostsListAiContentLibrary(postsListAiContentLibraryEl)
				);
			}
		);

		// posts list - event
		Array.from(document.querySelectorAll('.posts-list--event')).forEach((postsListEventEl) => {
			this.instances.components.postsListEvent.push(new PostsListEvent(postsListEventEl));
		});

		// posts list - partner
		Array.from(document.querySelectorAll('.posts-list--partner')).forEach(
			(postsListPartnerEl) => {
				this.instances.components.postsListPartner.push(
					new PostsListPartner(postsListPartnerEl)
				);
			}
		);

		// posts list - blog
		Array.from(document.querySelectorAll('.posts-list--blog')).forEach((postsListBlogEl) => {
			this.instances.components.postsListBlog.push(new PostsListBlog(postsListBlogEl));
		});

		// posts list - media coverage
		Array.from(document.querySelectorAll('.posts-list--media-coverage')).forEach(
			(postsListMediaCoverageEl) => {
				this.instances.components.postsListMediaCoverage.push(
					new PostsListMediaCoverage(postsListMediaCoverageEl)
				);
			}
		);

		// posts list - press release
		Array.from(document.querySelectorAll('.posts-list--press-release')).forEach(
			(postsListPressReleaseEl) => {
				this.instances.components.postsListPressRelease.push(
					new PostsListPressRelease(postsListPressReleaseEl)
				);
			}
		);
	}

	initTemplates() {
		// blog archive
		const archiveBlogEl = document.querySelector('.tmpl-archive-blog');

		if (archiveBlogEl) {
			this.instances.templates.archiveBlog = new ArchiveBlog(archiveBlogEl);
		}

		// search results
		const searchResultsEl = document.querySelector('.tmpl-search');

		if (searchResultsEl) {
			this.instances.templates.searchResults = new SearchResults(searchResultsEl);
		}

		// single post
		const singlePostEl = document.querySelector('.tmpl-single-post');

		if (singlePostEl) {
			this.instances.templates.singlePost = new SinglePost(singlePostEl);
		}
	}

	initBlocks() {
		// testimonials
		Array.from(document.querySelectorAll('.block-testimonials')).forEach(
			(testimonialsBlockEl) => {
				this.instances.blocks.testimonials.push(new BlockTestimonials(testimonialsBlockEl));
			}
		);

		// CTA
		Array.from(document.querySelectorAll('.block-cta')).forEach((ctaBlockEl) => {
			this.instances.blocks.cta.push(new BlockCTA(ctaBlockEl));
		});

		// Columns
		Array.from(document.querySelectorAll('.block-columns')).forEach((columnsBlockEl) => {
			this.instances.blocks.columns.push(new BlockColumns(columnsBlockEl));
		});

		// Stats
		Array.from(document.querySelectorAll('.block-stats')).forEach((statsBlockEl) => {
			this.instances.blocks.stats.push(new BlockStats(statsBlockEl));
		});

		// Media
		Array.from(document.querySelectorAll('.block-media')).forEach((mediaBlockEl) => {
			this.instances.blocks.media.push(new BlockMedia(mediaBlockEl));
		});

		// Sidebar anchor
		Array.from(document.querySelectorAll('.block-sidebar-anchor')).forEach(
			(sidebarAnchorBlockEl) => {
				this.instances.blocks.sidebarAnchor.push(
					new BlockSidebarAnchor(sidebarAnchorBlockEl)
				);
			}
		);

		// AutomationSidebar anchor
		Array.from(document.querySelectorAll('.tmpl-automation')).forEach(
			(sidebarAnchorBlockEl) => {
				this.instances.blocks.sidebarAnchor.push(
					new AutomationSidebarAnchor(sidebarAnchorBlockEl)
				);
			}
		);

		// AI Content Library Sidebar anchor
		Array.from(document.querySelectorAll('.tmpl-ai-content-library')).forEach(
			(sidebarAnchorBlockEl) => {
				this.instances.blocks.sidebarAnchor.push(
					new AIContentLibrarySidebarAnchor(sidebarAnchorBlockEl)
				);
			}
		);

		// Grid quick nav
		const quickNavEl = document.querySelectorAll('.quick-nav');
		const gridFilterEl = document.querySelectorAll('.grid-filters');
		const gridStickyEl = quickNavEl !== 0 ? gridFilterEl : quickNavEl;
		Array.from(gridStickyEl).forEach((gridQuickNavEl) => {
			this.instances.components.quickNav.push(new GridQuickNav(gridQuickNavEl));
		});

		// Related resources
		Array.from(document.querySelectorAll('.block-related-resources')).forEach(
			(relatedResourcesBlockEl) => {
				this.instances.blocks.relatedResources.push(
					new BlockRelatedResources(relatedResourcesBlockEl)
				);
			}
		);

		Array.from(document.querySelectorAll('.block-related-posts')).forEach(
			(relatedResourcesBlockEl) => {
				this.instances.blocks.relatedResources.push(
					new BlockRelatedResources(relatedResourcesBlockEl)
				);
			}
		);

		// Content Media (video only)
		Array.from(
			document.querySelectorAll('.block-content-media[data-media-type="video"]')
		).forEach((contentMediaBlockEl) => {
			this.instances.blocks.contentMedia.push(new BlockContentMedia(contentMediaBlockEl));
		});

		// setup block animation watcher
		const animateBlocks = document.querySelectorAll('.block-animate');

		if (animateBlocks && animateBlocks.length) {
			this.instances.blockAnimationWatcher = new BlockAnimationWatcher(animateBlocks);
		}
	}

	initSocialShare() {
		const socialShareEls = document.querySelectorAll('[data-social-share]');

		Array.from(socialShareEls).forEach((el) => {
			const site = el.getAttribute('data-social-share');
			const shareUrl = el.getAttribute('href');

			if (!shareUrl || site === 'email') {
				return;
			}

			el.addEventListener('click', (e) => {
				e.preventDefault();

				window.open(shareUrl, `${site}Share`, 'width=626,height=436');
			});
		});
	}

	initFX() {
		// setup parallax fx watcher
		const parallaxFxEls = Array.from(document.querySelectorAll('.fx--parallax'));

		if (parallaxFxEls.length) {
			this.instances.parallaxFxWatcher = new ParallaxFxWatcher(parallaxFxEls);
		}
	}
}

export default App;
